import Spinner from '../spinner/Spinner';

const HydrateFallbackSpinner = () => {
	return (
		<div className="w-full h-full flex justify-center items-center dark:bg-slate-900">
			<Spinner size={58} />
		</div>
	);
};

export default HydrateFallbackSpinner;
